import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  paper: {
    boxShadow: 'none',
    border: '1px solid #C6C6C6',
    marginBottom: '10px',
    overflow: 'hidden',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    contain: 'inline-size',
  },
  tableWrapper: {
    width: "100%",
    overflowX: "auto",
    overflowY: "auto",
    maxHeight: 440,
  },
  table: {
    width: '100%',
    tableLayout: 'auto',
    minWidth: 0,
  },
  headerCell: {
    backgroundColor: '#F9F9FC',
    fontWeight: "bold",
    padding: '12px 14px',
    position: 'sticky',
    top: 0,
    zIndex: 2,
    fontSize: '15px',
    whiteSpace: 'normal',
    wordBreak: 'normal',
    overflowWrap: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  tableCell: {
    padding: '12px 14px',
    borderBottom: '1px solid #C6C6C6',
    fontSize: '14px',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  uomCell: {
    padding: '12px 14px',
    whiteSpace: 'nowrap',
    borderBottom: '1px solid #C6C6C6',
    fontSize: '14px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  tableRow: {
    '&:last-child td': {
      borderBottom: 'none',
    },
  },
  pdfLink: {
    color: '#1976d2',
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));
